






















import { Component, Mixins, Prop, Provide, Watch } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw/index';
import { get } from 'lodash';

import { DrawSVG, ESide, TData, TDataExtended, TDatas } from '@/plugins/podolib/services/charts/gaitline/gaitline';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

@Component
export default class ChartRawGaitLine extends Mixins(MixinChartRaw) {
  @Prop({ default: 1 }) scale!: number;
  @Prop({ default: false }) relativeValues!: boolean;

  @Provide() alldata: any = {
    taligrade: { left: { abs: 0, rel: 0 }, right: { abs: 0, rel: 0 } },
    plantigrade: { left: { abs: 0, rel: 0 }, right: { abs: 0, rel: 0 } },
    digitigrade: { left: { abs: 0, rel: 0 }, right: { abs: 0, rel: 0 } },
    heel_strike: {
      value: {
        left: 0,
        right: 0,
      },
    },
    flat_foot: {
      value: {
        left: 0,
        right: 0,
      },
    },
    heel_off: {
      value: {
        left: 0,
        right: 0,
      },
    },
    toe_off: {
      value: {
        left: 0,
        right: 0,
      },
    },
  };
  @Provide() arrayValues: any = [
    {
      id: 'digit',
      type: 'digitigrade',
      name: 'propulsion',
      icon: 'propulsion',
      values: { left: { abs: 0, rel: 0 }, right: { abs: 0, rel: 0 } },
    },
    {
      id: 'planti',
      type: 'plantigrade',
      name: 'flat-foot',
      icon: 'flat-foot',
      values: { left: { abs: 0, rel: 0 }, right: { abs: 0, rel: 0 } },
    },
    {
      id: 'tali',
      type: 'taligrade',
      name: 'loading-value',
      icon: 'heel-strike',
      values: {},
    },
  ];
  @Provide() arrayIcons: any = [
    {
      id: 'digitigrade',
      icon: require(`@/assets/images/propulsion.svg`),
    },
    {
      id: 'plantigrade',
      icon: require(`@/assets/images/flat-foot.svg`),
    },
    {
      id: 'taligrade',
      icon: require(`@/assets/images/heel-strike.svg`),
    },
  ];

  @Provide() graphCanvas: DrawSVG | null = null;

  @Provide() currentValues: string = 'values';
  @Provide() loading: boolean = false;
  @Provide() overlay: boolean = false;

  get canDisplayGaitLine(): boolean {
    return (
      // @ts-ignore
      !!get(this.values.computed_data, 'left.aggregates.gaitline_foot_in', null)
    );
  }

  get taligrade() {
    return {
      left: {
        abs: this.$pdc.helper!.secToMs(this.values.computed_data.left.aggregates.loading_time.avg),
        rel: this.getPercentPhase(ESide.Left, this.values.computed_data.left.aggregates.loading_time.avg),
      },
      right: {
        abs: this.$pdc.helper!.secToMs(this.values.computed_data.right.aggregates.loading_time.avg),
        rel: this.getPercentPhase(ESide.Right, this.values.computed_data.right.aggregates.loading_time.avg),
      },
    };
  }
  get plantigrade() {
    return {
      left: {
        abs: this.$pdc.helper!.secToMs(this.values.computed_data.left.aggregates.flatfoot_time.avg),
        rel: this.getPercentPhase(ESide.Left, this.values.computed_data.left.aggregates.flatfoot_time.avg),
      },
      right: {
        abs: this.$pdc.helper!.secToMs(this.values.computed_data.right.aggregates.flatfoot_time.avg),
        rel: this.getPercentPhase(ESide.Right, this.values.computed_data.right.aggregates.flatfoot_time.avg),
      },
    };
  }
  get digitigrade() {
    return {
      left: {
        abs: this.$pdc.helper!.secToMs(this.values.computed_data.left.aggregates.propulsion_time.avg),
        rel: this.getPercentPhase(ESide.Left, this.values.computed_data.left.aggregates.propulsion_time.avg),
      },
      right: {
        abs: this.$pdc.helper!.secToMs(this.values.computed_data.right.aggregates.propulsion_time.avg),
        rel: this.getPercentPhase(ESide.Right, this.values.computed_data.right.aggregates.propulsion_time.avg),
      },
    };
  }

  get heel_strike(): TDataExtended {
    return {
      value: {
        left: get(this.values.computed_data, 'left.aggregates.gaitline_foot_in.avg', null),
        right: get(this.values.computed_data, 'right.aggregates.gaitline_foot_in.avg', null),
      },
      range0: -13.5,
      range1: -10,
      range2: -6,
      range3: -2,
    };
  }
  get flat_foot(): TDataExtended {
    return {
      value: {
        left: get(this.values.computed_data, 'left.aggregates.gaitline_FFI.avg', null),
        right: get(this.values.computed_data, 'right.aggregates.gaitline_FFI.avg', null),
      },
      range0: -13.5,
      range1: -10,
      range2: -7,
      range3: -3.5,
    };
  }
  get heel_off(): TDataExtended {
    return {
      value: {
        left: get(this.values.computed_data, 'left.aggregates.gaitline_FFO.avg', null),
        right: get(this.values.computed_data, 'right.aggregates.gaitline_FFO.avg', null),
      },
      range0: -15.5,
      range1: -11.5,
      range2: -6,
      range3: -2,
    };
  }
  get toe_off(): TDataExtended {
    return {
      value: {
        left: get(this.values.computed_data, 'left.aggregates.gaitline_foot_out.avg', null),
        right: get(this.values.computed_data, 'right.aggregates.gaitline_foot_out.avg', null),
      },
      range0: -7.5,
      range1: -9.5,
      range2: -0.5,
      range3: -2.5,
    };
  }

  get type(): 'rel' | 'abs' {
    return this.relativeValues ? 'rel' : 'abs';
  }

  @Watch('values', { deep: true })
  onValuesChange() {
    this.getAllData();
  }
  @Watch('relativeValues', { deep: true })
  onValuesTypeChange() {
    this.getAllData();
  }
  @Watch('isSelected', { deep: true })
  onSelectedChange() {
    this.getAllData();
  }

  getPercentPhase(side: ESide, value: number): number {
    const total =
      this.values.computed_data[side].aggregates.loading_time.avg +
      this.values.computed_data[side].aggregates.flatfoot_time.avg +
      this.values.computed_data[side].aggregates.propulsion_time.avg;
    return (value / total) * 100;
  }
  getAllData() {
    this.overlay = !this.canDisplayGaitLine;
    if (this.canDisplayGaitLine) {
      for (const val of [
        'taligrade',
        'plantigrade',
        'digitigrade',
        'heel_strike',
        'flat_foot',
        'heel_off',
        'toe_off',
      ]) {
        // @ts-ignore
        this.alldata[val] = this[val];

        if (val === 'digitigrade') this.arrayValues[0].values = this.alldata[val];
        if (val === 'plantigrade') this.arrayValues[1].values = this.alldata[val];
        if (val === 'taligrade') this.arrayValues[2].values = this.alldata[val];
      }
      this.graphCanvas = new DrawSVG(this.$refs['canvas'] as HTMLCanvasElement, this.alldata, this.type, this.patient);
      this.draw();
    }
  }
  draw() {
    requestAnimationFrame(() => {
      this.graphCanvas!.draw();
    });
  }

  mounted() {
    this.getAllData();
  }
}
